import React, { Fragment } from 'react';
import TopPanel from './TopPanel';
import ContentPanel from './ContentPanel';

const MetricLens = props => (
  <Fragment>
    <TopPanel {...props} />
    <ContentPanel />
  </Fragment>
);

export default MetricLens;
